import CellBackgroundColor from './CellBackgroundColor';

export default CellBackgroundColor;